import { forwardRef } from 'react';
import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

type Variant = 'surface' | 'sunken' | 'outline';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: Variant;
  interactive?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

const variants: Record<Variant, string> = {
  surface: 'bg-surface shadow-card',
  sunken: 'bg-surface-2',
  outline: 'bg-transparent border border-line',
};

const paddings: Record<NonNullable<CardProps['padding']>, string> = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6',
};

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { variant = 'surface', interactive = false, padding = 'md', className, children, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        'rounded-xl',
        variants[variant],
        paddings[padding],
        interactive &&
          'cursor-pointer transition-[transform,opacity] duration-150 ease-smooth active:scale-[0.99] active:opacity-80',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
});
